import { Color as RcColor } from '../vc-color-picker';
export const toHexFormat = (value, alpha) => value?.replace(/[^\w/]/gi, '').slice(0, alpha ? 8 : 6) || '';
export const getHex = (value, alpha) => (value ? toHexFormat(value, alpha) : '');
export class ColorFactory {
    /** Original Color object */
    metaColor;
    constructor(color) {
        this.metaColor = new RcColor(color);
    }
    toHsb() {
        return this.metaColor.toHsb();
    }
    toHsbString() {
        return this.metaColor.toHsbString();
    }
    toHex() {
        return getHex(this.toHexString(), this.metaColor.getAlpha() < 1);
    }
    toHexString() {
        return this.metaColor.getAlpha() === 1
            ? this.metaColor.toHexString()
            : this.metaColor.toHex8String();
    }
    toRgb() {
        return this.metaColor.toRgb();
    }
    toRgbString() {
        return this.metaColor.toRgbString();
    }
}
